import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { MdHelpOutline } from 'react-icons/md';
import './InfoTooltip.css';

interface InfoTooltipProps {
  text: string;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({ text }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const containerRef = useRef<HTMLDivElement>(null);
  const IconComponent = MdHelpOutline as React.ComponentType<{ className?: string }>;

  useEffect(() => {
    if (isVisible && containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      setPosition({
        top: rect.top - 8, // Position above the icon
        left: rect.left + rect.width / 2, // Center horizontally
      });
    }
  }, [isVisible]);

  return (
    <div 
      ref={containerRef}
      className="info-tooltip-container"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      <IconComponent className="info-tooltip-icon" />
      {isVisible && createPortal(
        <div 
          className="info-tooltip-popup"
          style={{
            top: `${position.top}px`,
            left: `${position.left}px`,
            transform: 'translate(-50%, -100%)',
          }}
        >
          {text}
        </div>,
        document.body
      )}
    </div>
  );
};

export default InfoTooltip;
